import { gql } from "@apollo/client";


const ILT_SESSION_QUERY = gql`
query GetSession($iltID: UUID!, $sessionID: UUID!) {
  session(iltID: $iltID, sessionID: $sessionID) {
    node {
        id
        companyId
        instructorLedTrainingId
        locales {
            locale
            name
        }
        status
        maxSeats
        filledSeats
        completionCount
        timezone
        address {
            id
            companyId
            label
            name
            addressLine1
            addressLine2
            locality
            administrativeArea
            postalCode
            country {
                id
                code
                name
            }
            comment
            createdAt
            updatedAt
        }
        instructors {
            id
            companyId
            name
            description
            title
            createdAt
            updatedAt
        }
        completionCodes {
            id
            companyId
            instructorLedTrainingId
            code
            sessionCompletionsCount
            usedBySessionsCount
            createdAt
            deletedAt
        }
        sessionRegistrations {
            id
            companyId
            sessionId
            personId
            createdAt
            person {
                id
                username
                givenName
                surname
                email
            }
        }
        meetingUrl
        registrationUrl
        registrationOpenAt
        registrationCloseAt
        sessionStartAt
        sessionEndAt
        createdAt
        updatedAt
        canceledAt
        deletedAt
    }
  }
}`;

export default ILT_SESSION_QUERY;